export var IngestionPipelineDeadLetterSortField;
(function (IngestionPipelineDeadLetterSortField) {
    IngestionPipelineDeadLetterSortField["INGESTION_PIPELINE_DEAD_LETTER_SORT_FIELD_DLQ_PATH"] = "dlqPath";
})(IngestionPipelineDeadLetterSortField || (IngestionPipelineDeadLetterSortField = {}));
